import PanelBarNavContainer from "./Layout"

export const Home = () => {
  return (
    <div>
      <PanelBarNavContainer />
    </div>
  );
};